module.exports = __webpack_public_path__ + "img/empty.e14e69d6.png";